import React from 'react';
import { connect } from 'react-redux';

class Contributions extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      history: [],
      openHistory: false,
    };
  }
  render() {
    const { contributions } = this.props;
    return (
      <iframe
        class="airtable-embed"
        src={`https://airtable.com/embed/${contributions}?backgroundColor=grayLight&viewControls=on`}
        frameborder="0"
        onmousewheel=""
        width="100%"
        height="100%"
        // style="background: transparent; border: 1px solid #ccc;"
      ></iframe>
    );
  }
}

const mapStateToProps = (state) => ({
  contributions: state.place.airtable.contributions,
});

export default connect(mapStateToProps)(Contributions);
